import { DealerProfileType } from "@masterffl/dealer-profile-component";


export interface TransferModalProps {
    isOpen: boolean;
    onClose: () => void;
    dealerDetail?: DealerProfileType;
    refetchData?: () => void;
}
export interface SotModalProps {
    data:DealerProfileType
    isOpen: boolean;
    onClose: () => void;
}  
export enum Toastertype {
  success = 'success',
  error = 'error'
}

export enum TransferFormMode {
  TRANSFER_EDIT = 'TRANSFER_EDIT'
}

export enum LastMessageStatusEnum {
  sent,
  delivered,
  error,
  bounced,
  opened
}

enum CertificateWorkflowStatusStep {
  license_image_optimizer,
  ocr_check,
  license_validator,
  ez_validator
}


export interface TransferDetailsType {
  TransferDetails: {
    message: {
      usedEmail: string;
      lastMessageStatus: LastMessageStatusEnum| null;
      lastMessageSent: number | null;
    };
    certificateWorkflowStatus: {
      step: CertificateWorkflowStatusStep | null;
      status: string;
      time: number | null;
    };
    optChoice: {
      value: string;
      time: number | null;
    };
    products: Array<string> | null;
    status: string;
    buyer: {
      street: string | null;
      city: string | null;
      state: string | null;
      zipCode: string | null;
      name: string;
      phone: string;
      email: string;
    };
    orderId: string;
    transfer_proof_link?: string;
    notes: string;
    orderDate: string;
    storeURL: string | null;
    modelType: string;
    shippingAddress: {
      state: string;
      street: string;
      city: string;
      zipCode: string;
    } | null;
    transferId: string;
    isArchive?: boolean;
    agentName: string;
    agentEmail: string;
    transferType: string | null;
    transferCode: string;
    microStatus: string | null;
    numberOfDealerAssgined: number;
    version: number;
  };
  fflMasterDetails: {
    licenseId: string;
    contactName: Array<string> | null;
    businessType: string;
    email: Array<string> | [];
    contactNumber: Array<string> | [];
    businessName: string | null;
  };
  SellerDetails: {
    licenseId?: string;
    storeName?: string;
  };
}

export interface OptInModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  data: DealerProfileType;
}

export interface SotEnableModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: DealerProfileType;
}

export interface addressType {
  state: string;
  zipCode: string;
  street: string;
  city: string;
}